import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import TableCell from './TableCell'
import TableCellNow from './TableCellNow'
import TableCellPnl from './TableCellPnl'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'


const TableRow = memo(({ positionId, titles, currentTab}) => {
	const { theme } = useDefaultComponentTools()
	return (
		<Box
			sx={{
				alignItems: 'center',
				borderBottom: theme.palette.border,
				display: 'flex',
				justifyContent: 'space-between',
				minHeight: '57px',
				p: '12px'
			}}
		>
			{titles.map((cell, index) =>
				cell.id === 'now' || cell.id === 'pnl_close' ?
					(cell.id === 'now' ? <TableCellNow
						key={index}
						cell={cell}
						positionId={positionId}
					/> : <TableCellPnl
						key={index}
						cell={cell}
						positionId={positionId}
					/>) :
					<TableCell
						currentTab={currentTab}
						key={index}
						index={index}
						cell={cell}
						positionId={positionId}
					/>
			)}
		</Box>
	)
})

TableRow.propTypes = {
	currentTab: PropTypes.string,
	positionId: PropTypes.string,
	setPositionInfoId: PropTypes.func,
	titles: PropTypes.array
}

TableRow.displayName = 'AppTable'

export default TableRow
